import { Button } from "components"
import { useTranslation } from "react-i18next"

interface props {
 handleShow?: () => void
 name?: string
}
export const Warning = ({ handleShow, name }: props) => {
 // language translator
 const { t } = useTranslation("translation")
 return (
  <>
   <div className="w-[96%] mx-auto">
    <h1 className="jakarta-font text-xl font-semi pt-6">{name}</h1>
    <div className=" bg-light-red flex justify-between lg:flex-row flex-col px-4 py-4 mt-4 border-red border rounded Jakarta-font ">
     <div>
      <h1 className="text-red ">Warning</h1>
      <p className="text-xs lg:py-0 py-3">
       6 planes selected. This can lead to long loading times. Confirm the selection or select few
       attachments
      </p>
     </div>
     <div>
      {" "}
      <Button onClick={handleShow} color={"yellow"} size={"xl"}>
       {t("confirmSelection")}
      </Button>
     </div>
    </div>
   </div>
  </>
 )
}
